/* ============================================================
   BEE LANDING v3 — Vanilla JS (sin dependencias, carga con defer)
   Aparición al scroll · galería táctil · variantes · packs
   barra fija · micro-interacciones · parallax · sonido del vídeo
   ============================================================ */
(function () {
  'use strict';

  /* El CSS sólo esconde los bloques que van a aparecer si esta clase
     existe. Si el JS fallara o no cargara, la web se ve entera. */
  document.documentElement.classList.add('bee-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  /* ---------------------------------------------------------
     1. APARICIÓN AL HACER SCROLL
     El observador por sí solo no basta: con un scroll muy rápido
     (o un salto de scroll) un bloque puede pasar de estar debajo
     del viewport a estar encima en un mismo fotograma, y entonces
     el observador nunca lo ve y el bloque se queda invisible.
     Por eso hay además un barrido en cada scroll.
     --------------------------------------------------------- */
  function initReveal() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.bee-reveal'));
    if (!items.length) return;

    function show(el) { el.classList.add('is-in'); }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(show);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    items.forEach(function (el) { io.observe(el); });

    function sweep() {
      var pending = document.querySelectorAll('.bee-reveal:not(.is-in)');
      if (!pending.length) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      var limit = window.innerHeight * 0.92;
      for (var i = 0; i < pending.length; i++) {
        if (pending[i].getBoundingClientRect().top < limit) {
          show(pending[i]);
          io.unobserve(pending[i]);
        }
      }
    }

    /* El barrido se llama directo, sin requestAnimationFrame: rAF no
       se ejecuta si la pestaña está en segundo plano, y entonces el
       contenido se quedaría escondido. Es barato porque sólo mide los
       bloques que faltan, y el listener se quita solo al terminar. */
    function onScroll() { sweep(); }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', onScroll);
    document.addEventListener('visibilitychange', onScroll);
    sweep();
  }

  /* ---------------------------------------------------------
     2. GALERÍA TÁCTIL
     --------------------------------------------------------- */
  var gallery = { goTo: function () {}, indexOfMedia: function () { return -1; } };

  function initGallery() {
    var wrap = document.querySelector('[data-bee-gallery]');
    if (!wrap) return;
    var track = wrap.querySelector('[data-bee-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.bee-gallery__slide'));
    var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-bee-dot]'));
    var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-bee-thumb]'));
    if (!slides.length) return;

    var current = 0;

    function setActive(index) {
      if (index === current || index < 0) return;
      current = index;
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(index);
    }

    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { goTo(i); }); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.55) {
            setActive(slides.indexOf(entry.target));
          }
        });
      }, { root: track, threshold: [0.55] });
      slides.forEach(function (s) { io.observe(s); });
    }

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(current + 1, slides.length - 1)); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(Math.max(current - 1, 0)); }
    });

    gallery.goTo = goTo;
    gallery.indexOfMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) return i;
      }
      return -1;
    };
  }

  /* ---------------------------------------------------------
     3. VARIANTES — la galería salta a la foto de la elegida
     --------------------------------------------------------- */
  function initVariants() {
    var radios = Array.prototype.slice.call(document.querySelectorAll('[data-bee-variant]'));
    if (!radios.length) return;

    function apply(radio, jump) {
      var name = document.querySelector('[data-bee-variant-name]');
      if (name) name.textContent = radio.getAttribute('data-name') || '';

      if (jump) {
        var idx = gallery.indexOfMedia(radio.getAttribute('data-media'));
        if (idx >= 0) gallery.goTo(idx);
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { if (radio.checked) apply(radio, true); });
      if (radio.checked) apply(radio, false);
    });
  }

  /* ---------------------------------------------------------
     4. PACKS — fijan la cantidad y refrescan la barra fija.
     Los importes NO se calculan aquí: vienen ya escritos por
     Liquid con el formato de moneda de la tienda, así nunca
     aparecen dos formatos distintos en la misma página.
     --------------------------------------------------------- */
  function applyBundle(radio) {
    var qtyInput = document.querySelector('[data-bee-qty]');
    if (qtyInput) qtyInput.value = radio.getAttribute('data-qty') || '1';

    var sPrice = document.querySelector('[data-bee-sticky-price]');
    var sCompare = document.querySelector('[data-bee-sticky-compare]');
    if (sPrice) sPrice.textContent = radio.getAttribute('data-total-money') || sPrice.textContent;
    if (sCompare) sCompare.textContent = radio.getAttribute('data-full-money') || '';
  }

  function initBundles() {
    var radios = Array.prototype.slice.call(document.querySelectorAll('[data-bee-bundle]'));
    if (!radios.length) return;
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { if (radio.checked) applyBundle(radio); });
      if (radio.checked) applyBundle(radio);
    });
  }

  /* ---------------------------------------------------------
     5. BARRA FIJA DE COMPRA
     --------------------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-bee-sticky]');
    var anchor = document.querySelector('[data-bee-sticky-anchor]');
    if (!bar || !anchor) return;

    if (!('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
      });
    }, { threshold: 0 });

    io.observe(anchor);
  }

  /* ---------------------------------------------------------
     6. AÑADIR AL CARRITO (AJAX)
     --------------------------------------------------------- */
  function initCartForm() {
    var form = document.getElementById('bee-atc-form');
    if (!form) return;

    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-bee-submit]'));

    function setLabel(btn, text) {
      var label = btn.querySelector('.bee-cta__label');
      if (label) label.textContent = text;
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();

      var data = new FormData(form);
      buttons.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart-add-failed');
          return res.json();
        })
        .then(function () {
          buttons.forEach(function (b) {
            b.classList.remove('is-loading');
            b.classList.add('is-success');
            setLabel(b, '✓ AÑADIDO AL CARRITO');
          });
          // TRACKING: aquí se dispara AddToCart (Meta Pixel / GA4)
          if (typeof window.fbq === 'function') { window.fbq('track', 'AddToCart'); }
          if (typeof window.gtag === 'function') { window.gtag('event', 'add_to_cart'); }
          window.setTimeout(function () { window.location.href = root + 'cart'; }, 650);
        })
        .catch(function () {
          buttons.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; });
          form.submit();
        });
    });
  }

  /* ---------------------------------------------------------
     7. VÍDEO — botón de sonido
     --------------------------------------------------------- */
  function initVideo() {
    var btn = document.querySelector('[data-bee-sound]');
    if (!btn) return;
    var video = document.querySelector('[data-bee-video]') || document.querySelector('.bee-demo__frame video');
    if (!video) { btn.remove(); return; }

    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      btn.setAttribute('aria-pressed', String(!video.muted));
      btn.setAttribute('aria-label', video.muted ? 'Activar sonido del vídeo' : 'Silenciar el vídeo');
      btn.querySelectorAll('[data-icon]').forEach(function (icon) {
        icon.hidden = icon.getAttribute('data-icon') !== (video.muted ? 'muted' : 'sound');
      });
      if (video.paused) { video.play().catch(function () {}); }
    });
  }

  /* ---------------------------------------------------------
     8. PARALLAX (sólo ordenador)
     --------------------------------------------------------- */
  function initParallax() {
    if (reduceMotion || window.innerWidth < 990) return;
    var layers = Array.prototype.slice.call(document.querySelectorAll('[data-bee-parallax]'));
    if (!layers.length) return;

    var ticking = false;

    function update() {
      var vh = window.innerHeight;
      layers.forEach(function (layer) {
        var rect = layer.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var speed = parseFloat(layer.getAttribute('data-bee-parallax')) || 0.06;
        var offset = (rect.top + rect.height / 2 - vh / 2) * -speed;
        layer.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  }

  /* --------------------------------------------------------- */
  function boot() {
    initReveal();
    initGallery();
    initVariants();
    initBundles();
    initSticky();
    initCartForm();
    initVideo();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
